import { Typography } from '@workspace/ui/components/Typography';
import { useBreakpoint } from '@workspace/ui/hooks/useBreakpoint';
import {
  Cart24,
  Heart24,
  QrCode24,
  Search24,
  User24,
} from '@workspace/ui/icons';
import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SearchBar } from '~/components/HeaderV3/components/SearchBar';
import { HeaderFavs } from '~/components/MobileHeaderCD/components/HeaderFavs';
import { ModalType } from '~/components/Modal/interface';
import { ModalClientCard } from '~/components/ModalClientCard';
import { useModal } from '~/hooks/useModal';
import { userStore } from '~/stores';
import { favoritesStore } from '~/stores/FavoritesStore/FavoritesStore';
import { HeaderCartButton } from './HeaderCartButton';

export const HeaderNavigation = observer(() => {
  const { isMobile } = useBreakpoint();
  const { openModal } = useModal();
  const navigate = useNavigate();

  const [isClientCardOpen, setIsClientCardOpen] = useState(false);

  const favsCount = favoritesStore.favorites.length;

  const handleCloseClientCard = useCallback(
    () => setIsClientCardOpen(false),
    [],
  );

  const handleClientCard = () => {
    if (!userStore.isAuthorized) {
      openModal(ModalType.Auth);
      return;
    }
    setIsClientCardOpen(true);
  };

  const handleSearch = (e: React.MouseEvent) => {
    if (!isMobile) return;

    e.preventDefault();
    navigate('/search');
  };

  const handleAuth = (e: React.MouseEvent) => {
    if (userStore.isAuthorized) {
      return;
    }
    e.preventDefault();
    openModal(ModalType.Auth, 'header', {
      redirect: '/cabinet',
    });
  };

  return (
    <>
      <SearchBar
        trigger={
          <div>
            <Search24 />
          </div>
        }
        fixedWidth={600}
        onClick={handleSearch}
      />
      {isMobile ? (
        <>
          <button
            type="button"
            aria-label="Client card"
            onClick={handleClientCard}
            className="cursor-pointer border-none bg-transparent"
          >
            <QrCode24 className="text-graphic-regular-white! transition-colors duration-300 group-data-[scrolled=true]:text-icon-primary!" />
          </button>
          <ModalClientCard
            isOpen={isClientCardOpen}
            onClose={handleCloseClientCard}
          />
        </>
      ) : (
        <>
          <HeaderFavs
            enableCaption={false}
            enableLabel={false}
            icon={
              <>
                <Heart24 />
                {favsCount > 0 && (
                  <Typography.Text200Semibold
                    as="span"
                    className="absolute -top-[10px] -right-[14px] size-6 rounded-full bg-action-brand p-1 text-center text-text-in-button"
                  >
                    {favsCount}
                  </Typography.Text200Semibold>
                )}
              </>
            }
            className="max-h-max text-graphic-regular-white! transition-colors duration-300 group-data-[scrolled=true]:text-icon-primary!"
            dropdownClassName="max-w-[480px] right-[128px] left-auto! transform-[translate(0)]! bg-bg-base!"
          />
          <Link
            to="/cabinet"
            onClick={handleAuth}
            data-link="header-cabinet"
            className="text-graphic-regular-white! transition-colors duration-300 group-data-[scrolled=true]:text-icon-primary!"
          >
            <User24 />
          </Link>
          <HeaderCartButton>
            <Cart24 />
          </HeaderCartButton>
        </>
      )}
    </>
  );
});
